export interface Result<Success, Error> {
	readonly error: Error | null;
	readonly isLoading: boolean;
	readonly isResolved: boolean;
	readonly value: Success | null;

	map<NewSuccess>(mapper: (success: Success) => NewSuccess): Result<NewSuccess, Error>;
	mapError<NewError>(mapper: (error: Error) => NewError): Result<Success, NewError>;
}

// tslint:disable-next-line: max-classes-per-file
export class Initial<Success, Error> implements Result<Success, Error> {
	public readonly error: null = null;
	public readonly isLoading = false as const;
	public readonly isResolved = false as const;
	public readonly value: null = null;

	public map<NewSuccess>(_: (success: Success) => NewSuccess): Result<NewSuccess, Error> {
		return new Initial();
	}

	public mapError<NewError>(_: (error: Error) => NewError): Result<Success, NewError> {
		return new Initial();
	}
}

// tslint:disable-next-line: max-classes-per-file
export class Success<Success, Error> implements Result<Success, Error> {
	public readonly error: null = null;
	public readonly isLoading = false as const;
	public readonly isResolved = true as const;

	public constructor(public readonly value: Success) {}

	public map<NewSuccess>(mapper: (success: Success) => NewSuccess): Result<NewSuccess, Error> {
		return new Success(mapper(this.value));
	}

	public mapError<NewError>(_: (error: Error) => NewError): Result<Success, NewError> {
		return new Success(this.value);
	}
}

// tslint:disable-next-line: max-classes-per-file
export class Failure<Success, Error> implements Result<Success, Error> {
	public readonly isLoading = false as const;
	public readonly isResolved = true as const;
	public readonly value: null = null;

	public constructor(public readonly error: Error) {}

	public map<NewSuccess>(_: (success: Success) => NewSuccess): Result<NewSuccess, Error> {
		return new Failure(this.error);
	}

	public mapError<NewError>(mapper: (error: Error) => NewError): Result<Success, NewError> {
		return new Failure(mapper(this.error));
	}
}

// tslint:disable-next-line: max-classes-per-file
export class Loading<Success, Error> implements Result<Success, Error> {
	public readonly error: null = null;
	public readonly isLoading = true as const;
	public readonly isResolved = false as const;

	public constructor(public readonly value: Success | null) {}

	public map<NewSuccess>(mapper: (success: Success) => NewSuccess): Result<NewSuccess, Error> {
		return new Loading<NewSuccess, Error>(this.value !== null ? mapper(this.value) : null);
	}

	public mapError<NewError>(_: (error: Error) => NewError): Result<Success, NewError> {
		return new Loading(this.value);
	}
}
